import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FusionAuthService } from '@fusionauth/angular-sdk';
import { MenuService } from '../../services/menu.service';
import { NavItem } from '../../interfaces/nav-item.interface';
import { environment } from 'src/environments/environment';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: [],
})
export class MenuComponent implements OnInit {
  public menuItems!: any;
  public faSearch = faSearch;

  constructor(
    private fusionAuth: FusionAuthService,
    private menuService: MenuService,
    private userService: UserService
  ) {}

  async ngOnInit() {
    this.getMenuItems();
  }

  manageAction(action: string) {
    if (action == 'LOGOUT') this.fusionAuth.logout();
  }

  getMenuItems(mobile: boolean = false) {
    this.userService.getUser().then((value: any) => {
      value.subscribe((user: any) => {
        let community_shop = false;
        if (user != null) {
          community_shop = user.roles.indexOf(this.userService.ROLE_VIEW_COMMUNITY_SHOP) > -1;
        }
        this.menuService.getMenuItems().then((res: any) => {
          this.menuItems = res;
        });
      });
    });
  }
}
